import Phaser from 'phaser';

import { Scenes } from '../../utils/enums/scenes';
import { UI } from '../ui/ui';

export class PauseGame extends Phaser.Scene {
  private countdownText: Phaser.GameObjects.Text | null = null;

  constructor() {
    super(Scenes.PAUSE_GAME);
  }

  create(): void {
    this.renderPauseUI();
    this.setupHomeButton();
    this.setupContinueButton();
  }

  private renderPauseUI(): void {
    UI.text.PauseGame(this);
  }

  private setupContinueButton(): void {
    const [continueBtn, continueText] = UI.buttons.ContinueBtn(this, () => {
      continueBtn.setVisible(false);
      continueText.setVisible(false);
      this.startCountdown();
    });
  }

  private setupHomeButton(): void {
    UI.icons.HomeIcon(this, { interactive: true }).on('pointerdown', () => {
      this.scene.stop();
      this.scene.start(Scenes.EXIT_GAME);
    });
  }

  private startCountdown(): void {
    let countdown = 3;

    this.countdownText = this.add
      .text(this.cameras.main.centerX, this.cameras.main.centerY, countdown.toString(), {
        fontSize: '64px',
        color: '#000',
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    this.time.addEvent({
      delay: 1000,
      repeat: 2,
      callback: () => {
        countdown -= 1;
        this.countdownText?.setText(countdown.toString());

        if (countdown === 0) {
          this.resumeGame();
        }
      },
    });
  }

  private resumeGame(): void {
    this.countdownText?.destroy();

    const gameScene = this.scene.get(Scenes.GAME);
    gameScene.physics.resume();

    this.scene.resume(Scenes.GAME);
    this.scene.stop();

    document.body.style.cursor = 'none';
  }
}
